
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book-appointment-v3",
      function () {
        return require("private-next-pages/book-appointment-v3.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book-appointment-v3"])
      });
    }
  